// extracted by mini-css-extract-plugin
export default {"dropzone":"Uploader_dropzone__Y6xeK","active":"Uploader_active__XHwbU"};